/**
 * Contains offer related methods.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class OfferUtility {
    /**
     * Calculates a per-person price based on a package-price and a number of persons. Used for calculating prices for offers on a checklist.
     *
     * @param {number} packagePrice Package price
     * @param {number} personCount Number of persons
     * @returns {number} Price per person
     */
    public static calculatePricePerPerson(packagePrice: number, personCount: number): number {
        const result = packagePrice / personCount;
        return parseFloat(result.toFixed(2));
    }
}
